import { updateRatesEnterpriseCityRequest } from "../../data/ratesEnterpriseCityApi";
import { validateTarifaEnterpriseCityPayload } from "../validator/validateTarifaEnterpriseCityPayload";

export async function updateTarifaEnterpriseCityUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id de la tarifa ciudad a ciudad es obligatorio.");
  }

  const error = validateTarifaEnterpriseCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateRatesEnterpriseCityRequest(payload);
}
